(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailerblocks-promo-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rb-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-rb-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-rb-dot]'));
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== current;
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-selected', dotIndex === current ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(current + 1), Number(carousel.dataset.speed) || 5000);
      }
    };
    carousel.querySelector('[data-rb-prev]')?.addEventListener('click', () => {
      show(current - 1);
      start();
    });
    carousel.querySelector('[data-rb-next]')?.addEventListener('click', () => {
      show(current + 1);
      start();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.index));
      start();
    }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
